module.exports = __webpack_public_path__ + "static/img/6571_phase_function_Paper_PointsHejduk_Prediction.06b2dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6571_phase_function_Paper_PointsHejduk_Prediction.png
// module id = drvV
// module chunks = 0